export const ADMIN_V2_MODULES = [
  {
    menuItemKey: 'pricingmanagement',
    v1Component: 'pricingmanagement',
    v2Path: '/pricingmanagement'
  }
];

const ADMIN_V2_MENU_ITEM_KEYS = new Set(ADMIN_V2_MODULES.map((module) => module.menuItemKey));
const ADMIN_V2_V1_COMPONENTS = new Set(ADMIN_V2_MODULES.map((module) => module.v1Component));

export function isAdminV2MenuItemKey(menuItemKey) {
  return menuItemKey != null && ADMIN_V2_MENU_ITEM_KEYS.has(menuItemKey);
}

export function isAdminV2Path(pathname = window.location.pathname, search = window.location.search) {
  if (typeof pathname !== 'string') {
    return false;
  }

  for (const module of ADMIN_V2_MODULES) {
    if (pathname.startsWith(module.v2Path)) {
      return true;
    }
  }

  if (!pathname.startsWith('/v1bridge')) {
    return false;
  }

  const component = new URLSearchParams(search).get('component');
  return component != null && ADMIN_V2_V1_COMPONENTS.has(component);
}

export function isAdminShell(selectedMenuItem) {
  return isAdminV2MenuItemKey(selectedMenuItem) || isAdminV2Path();
}
